import { type ReactNode } from 'react';
import { ErrorText } from '@/components/ui/text';

export function RequiredMark() {
  return (
    <span className="text-lureo-danger-ink ml-0.5" aria-hidden>
      *
    </span>
  );
}

export function FieldError({ children }: { children: ReactNode }) {
  return <ErrorText className="mt-1.5">{children}</ErrorText>;
}

export function CharCounter({ length, min }: { length: number; min: number }) {
  const met = length >= min;
  return (
    <span
      className={`font-lureo-font-ui text-lureo-12 tabular-nums leading-[1.3] shrink-0 ${met ? 'text-lureo-brand-ink' : 'text-lureo-ink-subtlest'}`}
    >
      {length} / {min}
    </span>
  );
}
